import { yup } from '@guiker/yup-util'

export const leaseIdNested = yup.object({
  leaseId: yup.string().required(),
})

export type LeaseIdNested = yup.InferType<typeof leaseIdNested>
